import * as React from 'react';
import { Switch } from '@websky/core/src/Switch/components/Switch';
const PayByMilesSwitch = props => {
    return React.createElement(Switch, Object.assign({}, props, { switchPosition: "right" }));
};
export default PayByMilesSwitch;
